module.exports = __webpack_public_path__ + "assets/img/0507-gl.svg";